import { formatDateTime } from '../../../utils/format';
import { ORDER_STATE, historyDate, isPaidState } from '../orderState';

const STATUS_TEXT = {
  done: 'Completed',
  current: 'In progress',
  todo: 'Not started',
  failed: 'Not completed',
  stopped: 'Stopped',
};

// Steps are derived from order.state; dates come from the order and its status history.
const buildSteps = (order, state) => {
  const placed = { key: 'placed', label: 'Order placed', date: order.createdAt, status: 'done' };
  const submittedAt = historyDate(order, 'PAYMENT_SUBMITTED', 'PAYMENT_SUBMITED');
  const paidAt = order.paidAt || historyDate(order, 'PAYMENT_COMPLETED', 'PAID');
  const deliveredAt = order.deliveredAt || historyDate(order, 'DELIVERED');

  if (state === ORDER_STATE.CANCELLED) {
    return [
      placed,
      {
        key: 'cancelled',
        label: 'Order cancelled',
        date: order.cancelledAt || historyDate(order, 'CANCELLED'),
        status: 'stopped',
      },
    ];
  }

  if (state === ORDER_STATE.PAYMENT_FAILED) {
    return [
      placed,
      submittedAt && { key: 'submitted', label: 'Payment submitted', date: submittedAt, status: 'done' },
      { key: 'failed', label: 'Payment not completed', date: historyDate(order, 'PAYMENT_FAILED'), status: 'failed' },
      { key: 'paid', label: 'Payment verified', status: 'todo' },
      { key: 'delivered', label: 'Access delivered', status: 'todo' },
    ].filter(Boolean);
  }

  const paid = isPaidState(state) || state === ORDER_STATE.REFUNDED;
  const steps = [placed];

  if (state === ORDER_STATE.PENDING_PAYMENT) {
    steps.push({ key: 'payment', label: 'Waiting for payment', status: 'current' });
  } else if (submittedAt || state === ORDER_STATE.PAYMENT_SUBMITTED) {
    steps.push({ key: 'submitted', label: 'Payment submitted', date: submittedAt, status: 'done' });
  }

  steps.push({
    key: 'paid',
    label: paid ? 'Payment verified' : 'Verifying payment',
    date: paid ? paidAt : null,
    status: paid ? 'done' : state === ORDER_STATE.PAYMENT_SUBMITTED ? 'current' : 'todo',
  });

  const delivered = state === ORDER_STATE.FULFILLED || (state === ORDER_STATE.REFUNDED && deliveredAt);
  steps.push({
    key: 'delivered',
    label: delivered ? 'Access delivered' : state === ORDER_STATE.PAID ? 'Preparing access' : 'Access delivered',
    date: delivered ? deliveredAt : null,
    status: delivered ? 'done' : state === ORDER_STATE.PAID ? 'current' : 'todo',
  });

  if (state === ORDER_STATE.REFUNDED) {
    steps.push({ key: 'refunded', label: 'Refunded', date: historyDate(order, 'REFUNDED'), status: 'stopped' });
  }
  return steps;
};

const OrderTimeline = ({ order, state }) => (
  <ol className="pk-timeline" aria-label="Order progress">
    {buildSteps(order, state).map(step => (
      <li key={step.key} className="pk-timeline__step" data-status={step.status} aria-current={step.status === 'current' ? 'step' : undefined}>
        <span className="pk-timeline__dot" aria-hidden="true" />
        <div className="pk-timeline__text">
          <span className="pk-timeline__label">
            {step.label}
            <span className="pk-account__sr"> ({STATUS_TEXT[step.status]})</span>
          </span>
          {step.date && <span className="pk-timeline__date">{formatDateTime(step.date)}</span>}
        </div>
      </li>
    ))}
  </ol>
);

export default OrderTimeline;
